import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { getUserByToken } from "./authCrud";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  SetUser: "[Set User] Action",
  RefreshToken: "[Refresh Token] Action",
};

const initialAuthState = {
  user: undefined,
  authToken: undefined,
  refreshToken: undefined,
  expireDate: undefined,
};

export const reducer = persistReducer(
  {
    storage,
    key: "VALUABLE",
    whitelist: [
      "user",
      "authToken",
      "refreshToken",
      "expireDate",
    ],
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        const {
          authToken,
          expireDate,
          refreshToken,
        } = action.payload;
        return {
          authToken,
          refreshToken,
          expireDate,
        };
      }

      case actionTypes.Register: {
        const { authToken } = action.payload;

        return { authToken, user: undefined };
      }

      case actionTypes.Logout: {
        // TODO: Change this code. Actions in reducer aren't allowed.
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.SetUser: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.RefreshToken: {
        const {
          authToken,
          expireDate,
          refreshToken,
        } = action.payload;

        return {
          ...state,
          authToken,
          expireDate,
          refreshToken,
        };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (authToken, expireDate, refreshToken) => ({
    type: actionTypes.Login,
    payload: { authToken, expireDate, refreshToken },
  }),
  register: (authToken) => ({
    type: actionTypes.Register,
    payload: { authToken },
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (user) => ({
    type: actionTypes.UserRequested,
    payload: { user },
  }),
  fulfillUser: (user) => ({
    type: actionTypes.UserLoaded,
    payload: { user },
  }),
  setUser: (user) => ({ type: actionTypes.SetUser, payload: { user } }),
  setRefreshToken: (authToken, expireDate, refreshToken) => ({
    type: actionTypes.RefreshToken,
    payload: { authToken, expireDate, refreshToken },
  }),
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const { data } = yield getUserByToken();

    yield put(actions.fulfillUser(data));
  });
}
